<div class="socials">

    <a
        href="https://www.regione.toscana.it/"
        target="_blank"
    >
        <img
            src="/assets/images/loghi/logo_regione.png"
            style="height: 40px"
            alt="Regione Toscana"
        />
    </a>

    <a
        href="https://www.regione.toscana.it/sst"
        target="_blank"
    >
        <img
            src="/assets/images/loghi/logo_asl_cut.png"
            style="height: 40px"
            alt="Sistema Sanitario della Toscana - MANAGEMENT E SANITÀ"
        />
    </a>

    <a
        href="https://www.santannapisa.it"
        target="_blank"
    >
        <img
            src="/assets/images/loghi/logo_sanna.png"
            style="height: 40px"
            alt="Scuola Universitaria Superiore Sant'Anna Pisa"
        />
    </a>

    <a
        href="https://www.santannapisa.it/it/istituto/management/mes-management-e-sanita"
        target="_blank"
    >
        <img
            src="/assets/images/loghi/logo_mes.jpg"
            style="height: 40px"
            alt="LABORATORIO MES - MANAGEMENT E SANITÀ"
        />
    </a>

</div>

<div class="app-stores">
    <a
        class="mr-4"
        href="https://play.google.com/store/apps/details?id=it.regione.toscana.happymamma&amp;hl=it&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    >
        <img
            src="/assets/badge_google_play.png"
            alt="Get it on Google Play"
            height="40"
        >
    </a>
    <a href="https://itunes.apple.com/us/app/happymamma/id1228624239">
        <img
            src="/assets/badge_apple_store.png"
            alt="Get it on Apple Store"
            height="40"
        >
    </a>
</div>

<nb-actions
    size="medium"
    class="header-container"
>

</nb-actions>

<div class="float-right version">
    v{{ version }} - server: {{ server_version }}
</div>
